module.exports = __webpack_public_path__ + "img/trunk_5x4.e7465fdf.svg";